import AppState from '../../types/app-state'

export const authTokenSelector = (state: AppState): string | undefined => state.auth.authToken

export const hasAuthTokenSelector = (state: AppState): boolean =>
    state.auth.authToken !== undefined && state.auth.authToken.length > 0
